export class DeviceDetector {
	static get isMobileTheme() {
		return WEBPACK_ENVIRONMENT_KEY === "MobileWeb";
	}

	static get isDesktopTheme() {
		return WEBPACK_ENVIRONMENT_KEY === "Web";
	}

	static get isMobileApp() {
		return navigator.userAgent.includes(AndroidAppUserAgent);
	}

	static get isIOS() {
		return (
			navigator.userAgent.includes("iPhone") ||
			navigator.userAgent.includes("iPad") ||
			navigator.userAgent.includes("iPod")
		);
	}

	static get isAndroid() {
		return navigator.userAgent.includes("Android");
	}

	static get isDesktopChrome() {
		return (
			navigator.userAgent.indexOf("Safari") > -1 &&
			navigator.userAgent.includes("Chrome")
		);
	}

	static get isDesktopSafari() {
		return (
			navigator.userAgent.indexOf("Safari") > -1 &&
			!navigator.userAgent.includes("Chrome")
		);
	}

	static get isDesktopFirefox() {
		return navigator.userAgent.indexOf("Firefox") > -1;
	}

	static get isDesktopEdge() {
		return navigator.userAgent.indexOf("Edg") > -1;
	}

	static get isDesktopOpera() {
		return (
			navigator.userAgent.indexOf("OPR") > -1 ||
			navigator.userAgent.indexOf("Opera") > -1
		);
	}
}
